const gitTag = process.env.GIT_TAG || '';
const instance = process.env.PUBLIC_INSTANCE || '';
const env = process.env.PUBLIC_ENV || '';

const tagMatchesInstance = instance.length > 0 && gitTag.includes(instance);
const fallbackVersion = `${instance}-${env}-main`;

export const appVersion = tagMatchesInstance ? gitTag : fallbackVersion;
